import { RouterModule } from '@angular/router';

import * as VIEWS from './views';
import { AuthGuardService } from '~services';

// Load routes in routes module
export const AppRoutes = RouterModule.forRoot(
  [
    {
      path: 'error/unavailable',
      component: VIEWS.ErrorUnavailableViewComponent,
    },
    {
      path: 'error/:status',
      component: VIEWS.ErrorViewComponent,
    },
    {
      path: 'error/:status/:description',
      component: VIEWS.ErrorViewComponent,
    },
    {
      path: 'auth/login',
      component: VIEWS.AuthLoginViewComponent,
    },
    {
      path: 'auth/callback',
      component: VIEWS.AuthCallbackViewComponent,
    },
    {
      path: 'auth/mobilesso',
      component: VIEWS.MobileSSOViewComponent,
    },
    {
      path: 'auth/mobilesso-start',
      component: VIEWS.MobileSSOStartViewComponent,
    },
    {
      path: 'checkout/:id',
      component: VIEWS.CheckoutViewV2Component,
    },
    {
      path: 'checkout/:id/create',
      component: VIEWS.CreateCheckoutViewComponent,
      canActivate: [AuthGuardService],
    },
    {
      path: 'finalise',
      component: VIEWS.CompleteViewV2Component,
      canActivate: [AuthGuardService],
    },
    {
      path: 'pending',
      component: VIEWS.PendingComponent,
    },
    {
      path: '',
      component: VIEWS.HomeViewV2Component,
    },
    {
      path: '**',
      redirectTo: '',
    },
  ],
  {
    initialNavigation: 'disabled',
    scrollPositionRestoration: 'top',
  },
);
